import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ExternalAction, ExternalActionData } from '../external.action.interface';
import { UserService } from '@user';
import { MessagesService, MessageType } from '@ui-messages';
import { __i18n } from '@localisation';
import { HttpHelperService } from '@http';
import { GlobalEventBus, ActionEvents } from '@event-bus';
import { SiteInfoService } from '@site-info';
import { LoaderService } from '@loader';

@Injectable()
export class DeleteUserActions implements ExternalAction {
    constructor(
        private userService: UserService,
        private router: Router,
        private messageService: MessagesService,
        private helperService: HttpHelperService,
        private eventBus: GlobalEventBus,
        private siteInfo: SiteInfoService,
        private loader: LoaderService
    ) {}

    public name: string = 'delete-current-user';

    public async execute(data: ExternalActionData) {
        const loaderId = this.loader.start();
        try {
            const result = await this.userService.deleteCurrentUser();

            this.messageService.addMessage({
                text: __i18n('User successfully removed.', 'workflow.external.actions.user.deleted.message.success'),
                type: MessageType.success
            });

            this.messageService.addMessage({
                text: __i18n('User successfully removed.', 'workflow.external.actions.user.deleted.message.success'),
                type: MessageType.success,
                target: 'landingpage'
            });

            //delete session etc.
            this.eventBus.trigger(ActionEvents.disconnect, { reload : true});
            localStorage.removeItem('_lastroute');
        } catch (e) {
            this.handleError(e);
            console.error('Error while deleting user! [DeleteUserActions.execute]');
        } finally {
            this.loader.stop(loaderId);
        }
    }

    private handleError(e?: any) {
        const errorMessage = this.helperService.getErrorMessage(e);
        this.messageService.addMessage({
            text: errorMessage,
            type: MessageType.error
        });
    }
}
